/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanButton from 'vant/es/button'
import 'vant/es/button/style/less'
import '/Users/noromacpro/work/orale-h5/vant-extra/style-override/button.css'
import VanTab from 'vant/es/tab'
import 'vant/es/tab/style/less'
import VanTabs from 'vant/es/tabs'
import 'vant/es/tabs/style/less'


import { render, staticRenderFns } from "./index.vue.js?vue&type=template&id=2fcf411a!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=2fcf411a"
import script from "./index.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue.postcss?vue&type=style&index=0&id=2fcf411a&prod&lang=postcss&module=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=0&id=2fcf411a&prod&lang=postcss&module=true"
import style1 from "./index.vue.postcss?vue&type=style&index=1&id=2fcf411a&prod&lang=postcss!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=1&id=2fcf411a&prod&lang=postcss"
import style2 from "./index.vue.css?vue&type=style&index=2&id=2fcf411a&prod&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=2&id=2fcf411a&prod&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanButton,VanTab,VanTabs})
